(() => {
	"use strict";

	document.addEventListener("DOMContentLoaded", () => {
		/*======================================
	スクロールで順番にディレイ表示
	======================================*/
		const BASE_DELAY_MS = 100;
		const THRESHOLD_PX = -150;

		const getOrderFromClass = (el) => {
			const cls = Array.from(el.classList).find((c) =>
				/^js-fade-order-\d+$/.test(c),
			);
			if (!cls) return Number.POSITIVE_INFINITY;
			const n = Number(cls.replace("js-fade-order-", ""));
			return Number.isFinite(n) ? n : Number.POSITIVE_INFINITY;
		};

		const queued = new WeakSet();

		const groups = Array.from(
			document.querySelectorAll(".js-fade-group"),
		).map((groupEl) => {
			const targets = Array.from(groupEl.querySelectorAll(".js-fadein"))
				.map((el) => ({ el, order: getOrderFromClass(el) }))
				.sort((a, b) => a.order - b.order)
				// ブロック内の並び順（0,1,2,3...）を idx にする
				.map((item, idx) => ({ ...item, idx }));

			return { groupEl, targets };
		});

		const reveal = () => {
			const viewBottom = window.scrollY + window.innerHeight;

			groups.forEach(({ targets }) => {
				targets.forEach(({ el, idx }) => {
					if (el.classList.contains("is-active")) return;
					if (queued.has(el)) return;

					const top = el.getBoundingClientRect().top + window.scrollY;

					if (viewBottom >= top + THRESHOLD_PX) {
						queued.add(el);
						window.setTimeout(() => {
							el.classList.add("is-active");
						}, idx * BASE_DELAY_MS);
					}
				});
			});
		};

		window.addEventListener("load", reveal);
		window.addEventListener("scroll", reveal, { passive: true });
	});
})();
